import {
  NavButtonStyled,
  NavLinkStyled,
  WebsiteNavStyled,
} from '@OnArk/styles/SimpleNav.styled';

import React from 'react';

import Link from 'next/link';

import { mq } from '@hangar31/rc-layout';
import NavLink from '@OnArk/NavLink';
import LogoSVG from '@OnArk/SVGs/Logo';
import { beaconLogout } from '@OnArk/utils/beacon';
import { secureCookie } from '@OnArk/utils/cookieSecure';
import posthog from '@OnArk/utils/posthog';
import Cookies from 'universal-cookie';

function SimpleAdminNav({ state }: { state: 'LOGGED_IN' | 'PUBLIC' }) {
  const cookies = new Cookies();

  // Previously this registered a cookies.addChangeListener that reloaded
  // on any cookie change — fired on unrelated writes (PostHog, etc) and
  // raced with async auth flows. Logout below navigates explicitly now.
  return (
    <WebsiteNavStyled
      flex
      padding
      as="nav"
      justify="space-between"
      open={false}
      rowGap={2}
      size="none"
    >
      <Link passHref href="/">
        <LogoSVG
          css={mq({
            cursor: 'pointer',
            height: ['4rem', undefined, undefined, '5.7rem'],
            position: 'relative',
            width: 'auto',
            zIndex: 100,
          })}
          fill="#fff"
        />
      </Link>
      <div>
        {state === 'LOGGED_IN' && (
          <NavLinkStyled
            onClick={e => {
              e.preventDefault();
              cookies.set('onark-token', '', {
                path: '/',
                secure: secureCookie(),
              });
              posthog?.capture('logout');
              beaconLogout();
              window.location.href = '/';
            }}
          >
            Sign Out
          </NavLinkStyled>
        )}
        {state === 'PUBLIC' && (
          <>
            <NavLinkStyled as={NavLink} href="/login">
              Log In
            </NavLinkStyled>

            <NavButtonStyled as={NavLink} href="/sign-up">
              Try For Free
            </NavButtonStyled>
          </>
        )}
      </div>
    </WebsiteNavStyled>
  );
}

export default SimpleAdminNav;
